import React from "react";
import DescriptionBanner from "./DescriptionBanner";
import { Icon } from "./UI/Icon";
import { Link } from "react-router-dom";


export default function HeaderBanner({ linkTo = '', title = '', description = '' }) {
  return (
    <div className="bg-[#F5F5F5] z-20">
      <div className="max-w-7xl mx-auto p-5 flex gap-5 items-center">
        <DescriptionBanner title={title} description={description} />
        {linkTo ? <div className="h-8 border-l-2 border-black" /> : null}
        {linkTo ?
          <Link to={linkTo} className='flex gap-2 items-center hover:scale-105 duration-300'>
            <Icon name={'circlecross'} />
            Chiudi
          </Link>
          : null
        }
      </div>
      <div className="border-b-[1px] border-[#B8B8B8]" />
    </div>
  );
}
